/**
 * Highlight src file
 */
import { Browser } from '@syncfusion/ej2-base';
import { extend } from '@syncfusion/ej2-base';
import { Selection3D } from './selection';
/**
 * The `Highlight` module handles the highlight for chart.
 *
 * @private
 */
export class Highlight3D extends Selection3D {
    /**
     * Constructor for selection module.
     *
     * @param {Chart3D} chart - Chart3D instance.
     */
    constructor(chart) {
        super(chart);
        this.chart = chart;
        this.wireEvents();
    }
    /**
     * Binding events for highlight module.
     *
     * @returns {void}
     */
    wireEvents() {
        if (this.chart.isDestroyed) {
            return;
        }
        this.chart.on(Browser.touchMoveEvent, this.mouseMove, this);
    }
    /**
     * Unbinding events for highlight module.
     *
     * @returns {void}
     */
    unWireEvents() {
        if (this.chart.isDestroyed) {
            return;
        }
        this.chart.off(Browser.touchMoveEvent, this.mouseMove);
    }
    /**
     * Declares private variables for the highlight modules.
     *
     * @param {Chart3D} chart - The 3D chart for which private variables are being declared.
     * @returns {void}
     */
    declarePrivateVariables(chart) {
        this.styleId = chart.element.id + '_ej2_chart_highlight';
        this.unselected = chart.element.id + '_ej2_deselected';
        this.selectedDataIndexes = [];
        this.highlightDataIndexes = [];
        this.isSeriesMode = chart.highlightMode === 'Series';
    }
    /**
     * Invokes the highlighting functionality on a 3D chart.
     *
     * @param {Chart3D} chart - The 3D chart on which highlighting is being invoked.
     * @returns {void}
     */
    invokeHighlight(chart) {
        this.declarePrivateVariables(chart);
        this.series = extend({}, chart.visibleSeries, null, true);
        this.seriesStyles();
        this.currentMode = chart.highlightMode;
    }
    /**
     * Gets the module name for the highlighting functionality.
     *
     * @returns {string} The module name.
     */
    getModuleName() {
        return 'Highlight3D';
    }
    /**
     * To destroy the highlight module.
     *
     * @returns {void}
     * @private
     */
    destroy() {
        this.unWireEvents();
        // Destroy method performed here
    }
}
